module.exports = __webpack_public_path__ + "static/media/close.d8bd08a4.svg";